import { useEffect, useRef, useState } from 'react';

import { useFloodJobs } from '@/features/analytics/context/FloodJobsContext';
import { SarJobFailureModal } from '@/features/map/components/ui/SarJobFailureModal';
import type { FloodJob } from '@/mocks/floodJobs';

/**
 * Opens a failure modal when a map-submitted SAR job (activeSarJobId) transitions to failed.
 */
export function MapSarJobFailureModalHost() {
  const { jobs, activeSarJobId } = useFloodJobs();
  const prevStatusRef = useRef<Map<string, FloodJob['status']>>(new Map());
  const [failedJob, setFailedJob] = useState<FloodJob | null>(null);

  useEffect(() => {
    if (!activeSarJobId) return;

    const job = jobs.find((j) => j.id === activeSarJobId);
    if (!job) return;

    const prev = prevStatusRef.current.get(job.id);
    prevStatusRef.current.set(job.id, job.status);

    if (job.status !== 'failed' || prev === 'failed') return;

    const timer = window.setTimeout(() => setFailedJob(job), 0);
    return () => window.clearTimeout(timer);
  }, [jobs, activeSarJobId]);

  return (
    <SarJobFailureModal
      open={Boolean(failedJob)}
      job={failedJob}
      onClose={() => setFailedJob(null)}
    />
  );
}
